// https://api.whatsapp.com/send?phone=96555300444&text=*New Order : #0017*
// *(_Home Delivery_)*
//
// Crab Meat With Sweet Com Soup سلطعون اللحوم مع شوربة الذرة x 1
//
// Total Payable: *KWD 1.500*
//
//
// *_Address:_*
// KHODIYAR SOCIETY SHERI NO-1, KOTHARIYA ROAD
// 3456123455
//
// Please confirm via reply.

import { appendCurrency } from "app/utils/product";

export const BUSINESS_NAME = document.location.pathname.replace("/", "");

export const replaceToWhatsAppAPI = (
  orderNo: string,
  fromWhatsAppNo: string,
  products: any,
  cartCounts: any,
  itemNotes: any,
  deliveryOption: string,
  totalAmount: string,
  mobileNumber: string,
  address: string,
  discount?: number,
  extraCharge?: number,
  discountPercentage?: string
) => {
  let orderURLText = `*New Order: ${orderNo}* \n *(_${deliveryOption}_)*\n`;

  Object.keys(cartCounts).forEach((key: string) => {
    if (!cartCounts[key]) return;
    orderURLText += `• ${products[key]} x ${cartCounts[key]} ${
      itemNotes[key] ? `\n (Note: ${itemNotes[key]})` : ""
    }\n`;
  });
  if (discount) {
    orderURLText += `\n• Discount: *${appendCurrency(discount?.toString())}* ${
      discountPercentage ? `(${discountPercentage}%)` : ""
    } \n`;
  }
  if (extraCharge) {
    orderURLText += `${discount ? "" : "\n"}• Extra charge: *${appendCurrency(
      extraCharge?.toString()
    )}* \n`;
  }
  orderURLText += `\n• Total+Payable:+*${appendCurrency(
    totalAmount
  )}*\n\n *Address:*\n ${address}\n${mobileNumber}`;
  document.location.href = `https://api.whatsapp.com/send?phone=${fromWhatsAppNo}&text=${encodeURIComponent(
    orderURLText
  )}`;
};

export const getCartProducts = (productIds: string[]) => {
  return fetch(`/api/${BUSINESS_NAME}/cart?ids=${productIds.join(",")}`);
};

export const getBusinessData = () => {
  return fetch(`/api/${BUSINESS_NAME}`, {
    method: "GET",
  });
};

export const getOrderId = (request: any) => {
  const urlencoded = new URLSearchParams();
  Object.keys(request).forEach((key: string) => {
    urlencoded.append(
      key,
      typeof request[key] === "string"
        ? request[key] || ""
        : JSON.stringify(request[key])
    );
  });
  return fetch(`/api/order/${BUSINESS_NAME}`, {
    method: "POST",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Origin": "*",
    },
    body: urlencoded,
  });
};

export const DISCOUNT_TYPE = {
  Percentage: "Percentage",
  Fixed: "Fixed",
};

export const applyCouponCode = (couponCode: string, totalAmount: number) => {
  const urlencoded = new URLSearchParams(
    `code=${couponCode}&subtotal=${totalAmount}`
  );
  return fetch(`/api/discount/${BUSINESS_NAME}`, {
    method: "POST",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Origin": "*",
    },
    body: urlencoded,
  });
};
